import React from "react";
import { FaInstagram } from "react-icons/fa";
import "./SocialCards.css";

const InstagramCard = ({ profileImg, followers, posts, link }) => {
  return (
    <div className="instagram-card">
      <div className="ig-header">
        <div className="ig-logo-ring">
          <img
            src={profileImg}
            alt="Instagram Profile"
            className="ig-profile-img"
          />
        </div>
        <div className="ig-info">
          <h4 className="ig-username">allhomedesire</h4>
          <p className="ig-displayname">All Home Desiré</p>
          <div className="ig-stats">
            <p>
              <strong>{followers}</strong> followers
            </p>
            <p>
              <strong>{posts}</strong> posts
            </p>
          </div>
        </div>
        <FaInstagram className="ig-icon" />
      </div>

      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="ig-btn"
      >
        Visit Instagram
      </a>
    </div>
  );
};

export default InstagramCard;
